import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-506d69f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "run-status" }
const _hoisted_2 = { class: "result-footer error" }
const _hoisted_3 = { class: "tips" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-close" }, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "btns" }
const _hoisted_7 = ["enent-logicId"]
const _hoisted_8 = { class: "result-footer success" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-check" }),
  /*#__PURE__*/_createTextVNode("运行成功")
], -1))
const _hoisted_10 = [
  _hoisted_9
]

import { ref } from 'vue';
import CodeHelp from './CodeHelp.vue';
import CompareCode from "@/models/page/compareCode";


export default /*#__PURE__*/_defineComponent({
  __name: 'RunStatus',
  props: {
    item: {},
    showErrorHelp: { type: Boolean },
    showSuccessShare: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

let isShowHelp = ref(false);
const handleAnswerClick = () => {
  isShowHelp.value = true;
}

let answerData = ref({
  answer: props.item.solution,
  think: props.item.think,
  desc: props.item.desc
});


const closeHelp = (data: boolean) => {
  isShowHelp.value = data;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, [
          _hoisted_4,
          (_ctx.showErrorHelp)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "运行出错"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.item.think || _ctx.item.solution)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn",
                onClick: handleAnswerClick,
                "event-key": "PROGRAM:BUTTON_HINT",
                "enent-logicId": _ctx.item.logicId
              }, " 提示 ", 8, _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ], 512), [
        [_vShow, _ctx.showErrorHelp]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_8, _hoisted_10, 512), [
        [_vShow, _ctx.showSuccessShare]
      ])
    ]),
    (_unref(isShowHelp))
      ? (_openBlock(), _createBlock(CodeHelp, {
          key: 0,
          onClose: closeHelp,
          "answer-data": _unref(answerData)
        }, null, 8, ["answer-data"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})